import React from 'react';
const PaginationSnippet = () => (
  <pre>
    <code>
      <>
        <span className='cn'>&lt;div</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-button-group</span>
        <span className='cln'>"</span>
        <span className='cn'>&gt;</span>
      </>
      <br />
      <>
        &nbsp;<span className='cn'>&lt;button</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-button-main carve-wall-none</span>
        <span className='cln'>"</span>
        <span className='cln'> id="</span>
        <span className='cn'>prev</span>
        <span className='cln'>"</span>
        <span className='cn'>&gt;</span>
        <span className=''>❮</span>
        <span className='cn'>&lt;/button&gt;</span>
      </>
      <br />
      <>
        &nbsp;<span className='cn'>&lt;div</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-button-group</span>
        <span className='cln'>"</span>
        <span className='cln'> id="</span>
        <span className='cn'>pagination</span>
        <span className='cln'>"</span>
        <span className='cn'>&gt;</span>
      </>
      <br />
      <>
        &nbsp;&nbsp;<span className='cn'>&lt;button</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-button-vice</span>
        <span className='cln'>"</span>
        <span className='cn'>&gt;</span>1<span className='cn'>&lt;/button&gt;</span>
      </>
      <br />
      <>
        &nbsp;&nbsp;<span className='cn'>&lt;button</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-button-vice</span>
        <span className='cln'>"</span>
        <span className='cn'>&gt;</span>2<span className='cn'>&lt;/button&gt;</span>
      </>
      <br />
      <>
        &nbsp;&nbsp;<span className='cn'>&lt;button</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-button-vice</span>
        <span className='cln'>"</span>
        <span className='cn'>&gt;</span>3<span className='cn'>&lt;/button&gt;</span>
      </>
      <br />
      <>
        &nbsp;&nbsp;<span className='cn'>&lt;button</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-button-vice active</span>
        <span className='cln'>"</span>
        <span className='cn'>&gt;</span>4<span className='cn'>&lt;/button&gt;</span>
      </>
      <br />
      <>
        &nbsp;&nbsp;<span className='cn'>&lt;button</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-button-vice</span>
        <span className='cln'>"</span>
        <span className='cn'>&gt;</span>5<span className='cn'>&lt;/button&gt;</span>
      </>
      <br />
      <>
        &nbsp;&nbsp;<span className='cn'>&lt;button</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-button-vice</span>
        <span className='cln'>"</span>
        <span className='cn'>&gt;</span>6<span className='cn'>&lt;/button&gt;</span>
      </>
      <br />
      <>
        &nbsp;&nbsp;<span className='cn'>&lt;button</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-button-vice</span>
        <span className='cln'>"</span>
        <span className='cn'>&gt;</span>7<span className='cn'>&lt;/button&gt;</span>
      </>
      <br />
      <>
        &nbsp;&nbsp;<span className='cn'>&lt;button</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-button-vice</span>
        <span className='cln'>"</span>
        <span className='cn'>&gt;</span>8<span className='cn'>&lt;/button&gt;</span>
      </>
      <br />
      <>
        &nbsp;<span className='cn'>&lt;/div&gt;</span>
      </>
      <br />
      <>
        &nbsp;<span className='cn'>&lt;button</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-button-main carve-wall-none</span>
        <span className='cln'>"</span>
        <span className='cln'> id="</span>
        <span className='cn'>next</span>
        <span className='cln'>"</span>
        <span className='cn'>&gt;</span>
        <span className=''>❯</span>
        <span className='cn'>&lt;/button&gt;</span>
      </>
      <br />
      <>
        <span className='cn'>&lt;/div&gt;</span>
      </>
    </code>

  </pre>
);
export { PaginationSnippet };